module.exports = __webpack_public_path__ + "static/media/notification_survey_icon.ff8855f4.svg";